import React from "react";

import { Form, Formik } from "formik";

import CompellonApi from "apis/compellon";
import { Button, Pane, Toastr, Typography } from "clearsense-ui/components";

import {
  NEW_ANALYSIS_INITIAL_VALUES,
  NEW_ANALYSIS_VALIDATION_SCHEMA,
} from "./constants";
import AnalysisForm from "./Form";
import { handlePayload } from "./utils";

const NewAnalysis = ({
  isNewPaneOpen,
  setIsNewPaneOpen,
  fetchJobs,
  datasetParams,
}) => {
  const handleSubmit = async values => {
    try {
      const payload = handlePayload(values, datasetParams);
      await CompellonApi.createBinaryModel(payload);
      Toastr.success("Analysis created successfully");
    } catch (error) {
      logger.error(error);
    } finally {
      setIsNewPaneOpen(false);
      fetchJobs();
    }
  };

  return (
    <Pane isOpen={isNewPaneOpen} onClose={() => setIsNewPaneOpen(false)}>
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          Run Analysis
        </Typography>
      </Pane.Header>
      <Formik
        initialValues={NEW_ANALYSIS_INITIAL_VALUES}
        onSubmit={handleSubmit}
        validationSchema={NEW_ANALYSIS_VALIDATION_SCHEMA}
      >
        <Form noValidate>
          <Pane.Body>
            <AnalysisForm />
          </Pane.Body>
          <Pane.Footer className="space-x-2">
            <Button label="Run" type="submit" />
            <Button
              style="text"
              label="Cancel"
              onClick={() => setIsNewPaneOpen(false)}
            />
          </Pane.Footer>
        </Form>
      </Formik>
    </Pane>
  );
};

export default NewAnalysis;
